module.exports = __webpack_public_path__ + "img/gushi_2_new.2132b663.jpeg";